import { alpha, Stack, styled, SxProps } from '@mui/material';

const StyledPlaceholderWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.text.secondary,
  backgroundColor: alpha(theme.palette.secondary.light, 0.75),
  transition: theme.transitions.create('opacity', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  width: '100%',
  height: '100%',
  '&:hover': { opacity: 0.75 },
}));

interface MediaPlaceholderWrapperProps {
  sx?: SxProps;
  stackSX?: SxProps;
  children: React.ReactNode;
  isWaitUpload: boolean;
}

const MediaPlaceholderWrapper: React.FC<MediaPlaceholderWrapperProps> = ({
  children,
  sx = {},
  stackSX = {},
  isWaitUpload,
}) => {
  return (
    <StyledPlaceholderWrapper
      sx={
        [
          {
            ...(!isWaitUpload && { opacity: 0, color: 'common.white', bgcolor: 'grey.900' }),
            // ...((isDragReject || error) && { bgcolor: 'error.lighter' }),
          },
          sx,
        ] as SxProps
      }
    >
      <Stack
        spacing={0.5}
        sx={
          [
            { alignItems: 'center', color: isWaitUpload ? 'secondary.main' : 'background.default' },
            stackSX,
          ] as SxProps
        }
      >
        {children}
      </Stack>
    </StyledPlaceholderWrapper>
  );
};

export default MediaPlaceholderWrapper;
